import angular from 'angular';

import AttributesBuilderRowComponent from './attributes-builder-row.component';

const AttributesBuilderRowModule = angular
    .module('control-room.poi.components.poi-edit.components.attributes-builder.components.attributes-builder-row', [])
    .component('crAttributesBuilderRow', AttributesBuilderRowComponent);

export default AttributesBuilderRowModule;
